<template>
	<section class="countdown-timer">
		<h2 class="countdown-timer__title">Hurry! Discounts held for:</h2>
		<VueCountdown :time="duration * 60 * 1000">
			<div
				slot-scope="props"
				class="countdown-timer__values"
				:aria-label="`Remaining time ${remainingTime(props)}`"
			>
				<div class="countdown-timer__value">
					{{ parseFirstValue(props.minutes) }}
				</div>
				<div class="countdown-timer__value">
					{{ parseSecondValue(props.minutes) }}
				</div>
				<span class="countdown-timer__divider">:</span>
				<div class="countdown-timer__value">
					{{ parseFirstValue(props.seconds) }}
				</div>
				<div class="countdown-timer__value">
					{{ parseSecondValue(props.seconds) }}
				</div>
			</div>
		</VueCountdown>
	</section>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';

export default {
	components: {
		VueCountdown,
	},

	props: {
		duration: {
			type: Number,
			default: 0,
		},
	},

	methods: {
		parseValue(value) {
			return value.toString().padStart(2, '0').split('');
		},
		parseFirstValue(value) {
			return this.parseValue(value)[0];
		},
		parseSecondValue(value) {
			return this.parseValue(value)[1];
		},

		remainingTime(props) {
			return `${this.parseFirstValue(
				props.minutes
			)}${this.parseSecondValue(props.minutes)}:${this.parseFirstValue(
				props.seconds
			)}${this.parseSecondValue(props.seconds)}`;
		},
	},
};
</script>

<style lang="scss" scoped>
.countdown-timer {
	align-items: center;
	background: var(--red-100);
	border-radius: var(--size-xs);
	border: 1px solid var(--red-300);
	display: flex;
	justify-content: center;
	gap: var(--size-md);
	margin-bottom: var(--size-lg);
	padding: var(--size-sm) var(--size-md);
	text-align: center;

	&__title {
		color: var(--red-600);
		font-size: var(--size-base);
		font-weight: 700;
		text-align: left;
		margin: 0;
	}

	&__values {
		align-items: center;
		display: flex;
		gap: var(--size-xs);
	}

	&__divider {
		color: var(--red-600);
		font-size: var(--size-lg);
		line-height: 1;
	}

	&__value {
		background: var(--white);
		border-radius: var(--size-xs);
		box-shadow: var(--shadow-base);
		color: var(--gray-900);
		font-size: 18px;
		line-height: 1;
		font-weight: 700;
		padding: var(--size-sm) var(--size-xs);
	}
}
</style>
